import type { DeactivationDateResult } from '../ui/auto-upgrade-avoid-deactivation-modal/types';

export const getDeactivationDate = (
	trialEndDateTimestamp: string,
	daysToAdd?: number,
): DeactivationDateResult => {
	const date = new Date(trialEndDateTimestamp);
	if (daysToAdd) {
		date.setDate(date.getDate() + daysToAdd);
	}

	const dateString = new Date(date).toLocaleDateString(undefined, {
		month: 'long',
		day: 'numeric',
	});

	const dateStringWithYear = new Date(date).toLocaleDateString(undefined, {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});

	const daysLeft = Math.ceil((date.getTime() - Date.now()) / (1000 * 60 * 60 * 24));

	return { date, dateString, dateStringWithYear, daysLeft };
};
